<template>
  <v-container
    fluid
    class="d-flex justify-center align-center"
    pa-md-4
    pa-2
    style="min-height: 10vh; border-radius: 0; overflow: auto"
  >
    <v-row class="d-flex justify-center">
      <v-col cols="12" sm="6" md="4" lg="10">
        <v-card rounded="0">
          <v-toolbar flat dense color="#005F95">
            <div>
              <!-- Small to Large Screens -->
              <h1
                class="Limit-Toolbar"
                :style="{
                  fontSize: isSmall ? '11px' : isMedium ? '16px' : '20px',
                }"
              >
                DINERS CLUB {{ product }} ONLINE APPLICATION
              </h1>
            </div>
          </v-toolbar>

          <v-container
            fluid
            style="border: 1px solid #ccc; border-radius: 0; padding: 16px"
          >
            <v-container fluid style="border-radius: 0; padding: 16px">
              <v-row>
                <v-col cols="12">
                  <h1 class="Credit-Limit-Approve" style="text-align: left">
                    TECHNICAL ERROR
                  </h1>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="13">
                  <p style="text-align: left">
                    Thank you for applying for the Diners Club Card,
                    unfortunately there is a system issue. Please try again
                    later. If you have any questions or would like more
                    information, you are welcome to contact us at 0860-DINERS
                    (346377) and quote your reference number:
                    <b>{{ refNumber }}</b
                    >.
                  </p>
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="12" class="text-center">
                  <v-btn
                    style="border-radius: 0; width: 220px"
                    @click="gotoLandingPage()"
                    color="#005F95"
                    class="white--text"
                  >
                    CLOSE APPLICATION
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script setup>
/* eslint-disable */
import { onBeforeMount,computed, ref} from "vue";
import { useDisplay } from "vuetify/lib/framework.mjs";
import { useRouter } from "vue-router";

const refNumber = computed(() => sessionStorage.getItem("refNumber"));
const { smAndDown, mdAndUp, lgAndUp } = useDisplay();
const isSmall = smAndDown;
const isMedium = computed(() => mdAndUp.value && !lgAndUp.value);
const router = useRouter();
const product = ref("");
const prodtype = ref(sessionStorage.getItem("prodtype"));

const BeyondSelected = ref(false);

onBeforeMount(() => {
  // Get product type from session storage
  prodtype.value = sessionStorage.getItem("prodtype");

  const productMap = {
    platinum: "CREDIT CARD",
    shariah: "SHARI'AH CARD",
    beyond: "BEYOND CARD",
  };
  product.value = productMap[prodtype.value] || "CREDIT CARD";
  BeyondSelected.value = prodtype.value === "beyond";

});

const gotoLandingPage = () => {
  // Clear all session storage data
  sessionStorage.clear();
  // Navigate to landing page
  router.push("/");
};


</script>
<style></style>
